import { VHover } from 'vuetify/lib/components/VHover';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"resource-tile-container",on:{"click":_vm.onTileClick}},[_c('div',[_c('img',{staticClass:"resource-image",attrs:{"src":_vm.resource.imgUrl}})]),_c(VHover,{scopedSlots:_vm._u([{key:"default",fn:function({ hover }){return [_c('div',{staticClass:"overlay-container",style:({
				height: hover ? '90%' : '85px',
			})},[_c('div',{staticClass:"overlay-title"},[_vm._v(" "+_vm._s(_vm._f("truncate")(_vm.resource.name,{ length: 28 }))+" ")]),_c('div',{staticClass:"overlay-description"},[_vm._v(" "+_vm._s(_vm.resource.description)+" ")])])]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }